import { AndroidBetaPlacement } from "@/settings";

import { mixpanelTrack } from "./mixpanelTrack";

const SECTION = "Landing Pages";

type LandingSubsection =
  | "Get SBC Solver"
  | "Get My Evolutions"
  | "Get My Players";

export const trackLandingPageUpgrade = (subsection: LandingSubsection) =>
  mixpanelTrack("upgrade", {
    section: SECTION,
    subsection,
    context: "cta",
    action_type: "lifecycle",
  });

export const trackObjectivesWaitlistJoin = (form: "hero" | "bottom") =>
  mixpanelTrack("join_waitlist", {
    section: SECTION,
    subsection: "Objectives",
    form,
    context: "cta",
    action_type: "lifecycle",
  });

const APP_PROMO_LOCATION: Record<
  AndroidBetaPlacement,
  { section: string; subsection: string }
> = {
  front_page_banner: { section: "Front Page", subsection: "App Promo" },
  app_page: { section: SECTION, subsection: "App" },
};

export const trackGetApp = (placement: AndroidBetaPlacement) =>
  mixpanelTrack("get_app", {
    ...APP_PROMO_LOCATION[placement],
    context: "cta",
    action_type: "lifecycle",
  });

export const trackAppPromoShown = (placement: AndroidBetaPlacement) =>
  mixpanelTrack("app_promo_shown", APP_PROMO_LOCATION[placement]);
